import {Injectable, Optional} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Device, DeviceSearch, Pagination, ProductFacet, ProductSort} from '@kion/data-models';
import {HttpClient} from '@angular/common/http';
import {ApiConfig} from '../../../../../api-endpoint/src/lib/api.config';

interface IResponseItem {
  addressOwner: {
    companyName?: string,
    number?: string
  },
  equipmentDescription: string,
  addressLocation?: {
    companyName?: string,
    town?: string,
    number?: string
  }
  manufacturer: string,
  truckSeries: {
    code: string,
    images: FeatureImage[]
  },
  networkPartner: {
    name: string,
    uid: string,
    country: string
  },
  serialNumber: string,
  configurable?: boolean,
  purchasable?: boolean,
  externalId?: string,
  features?: Feature[],
  description: string
}

interface Feature {
  code: string,
  configurable: boolean,
  name: string,
  purchasable: boolean,
  sortOrder: number,
  description: string,
  summary: string
  url: string,
  usps: string,
  operatingElement: string
  price?: {
    currencyIso: string,
    formattedValue: string,
    priceType: string,
    value: number
  },
  images: FeatureImage[]
}

interface FeatureImage {
  altText: string,
  url: string
}

interface SearchResponse {
  devices: IResponseItem[],
  pagination: Pagination,
  sorts: ProductSort[]
  facets: ProductFacet[]
}

@Injectable({
  providedIn: 'root'
})
export class DeviceConnectors {

  private readonly _rootUrl: string;
  private readonly _baseSite: string;

  private route = '/devices/';

  constructor(
    @Optional() apiConfig: ApiConfig,
    private http: HttpClient,
  ) {
    this._rootUrl = apiConfig.rootUrl;
    this._baseSite = apiConfig.baseSite;
  }

  private static transformFromApi(response: IResponseItem): Device {
    return {
      ...response,
      id: response.serialNumber
    };
  }

  search(
    query: string,
    page: number,
    pageSize: number,
    sort: string
  ): Observable<DeviceSearch> {
    let searchOptions = 'currentPage=' + (page - 1) + '&pageSize=' + pageSize;
    if (query) {
      searchOptions = searchOptions + '&query=' + query;
    }
    if (sort) {
      searchOptions = searchOptions + '&sort=' + sort;
    }
    return this.http.get<SearchResponse>(this.getManyUrl() + '?' + searchOptions).pipe(
      map(
        (response: SearchResponse) => {
          return {
            pagination: response.pagination,
            devices: response.devices ? response.devices.map((responseItem: IResponseItem) => DeviceConnectors.transformFromApi(responseItem)) : [],
            sorts: response.sorts ? response.sorts : [],
            facets: response.facets ? response.facets : []
          }
        }
      ),
      catchError(
        error => throwError(error)
      )
    )
  }

  getDevice(factory: string, id: string): Observable<Device> {
    return this.http.get<IResponseItem>(this.getOneUrl(factory, id)).pipe(
      map(
        (response: IResponseItem) => DeviceConnectors.transformFromApi(response)
      ),
      catchError(error => throwError(error))
    )
  }

  protected getManyUrl() {
    return this._rootUrl + this._baseSite + this.route + 'search';
  }

  protected getOneUrl(factory: string, id: string) {
    return this._rootUrl + this._baseSite + this.route + 'manufacturer/' + factory + '/serialnumber/' + id
      ;
  }
}
